/**
 * @file JobSearchEmptySlot.tsx
 *
 * @fileoverview Renders customized image if no job is selected on job search.
 */

import React from 'react';
import RichFormattedMessage from '~/jobiqo/components/RichFormattedMessage';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import Image from '~/jobiqo/components/Image';
import styles from './jobSearchEmptyCustom.module.scss';

interface JobSearchEmptySlotProps {
  /**
   * The count of jobs.
   */
  totalCount?: Slottable<number>;
}

export const JobSearchEmptySlot = ({}: JobSearchEmptySlotProps) => {
  return (
    <div className={styles.emptySearchWrapper}>
      <Image
        alt={'Deine Ergebnisse'}
        src={'/static/images/job-search-empty.png'}
        width={540}
        height={675}
      />
      <Spacing />
      <div>
        <RichFormattedMessage
          id="job_detail_panel_instructions"
          defaultMessage={
            'To see all the details of a job posting please choose one from the list on the left.'
          }
        />
      </div>
    </div>
  );
};
export default JobSearchEmptySlot;
